import React, {useContext, useEffect, useState} from 'react';
import StaticForm from "./StaticForm/StaticForm";
import FormBuilder from "../FormBuilder/FormBuilder";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import {SetPrintDataContext} from "../../../Pages";


const MainFormBuilder = () => {

    const [valueState, setValueState] = useState("1")

    const [formData, setNewFormData] = useState(null)


    const inputDataType = (event) => {
        const value = event.target.value;
        setValueState(value);
    }

    function onSubmitHandler(input) {
        setNewFormData(input);
    }
    const setNeedToReloadSidebar = useContext(SetPrintDataContext);

    useEffect(() => {
        if (formData !== null) {
            // اینجا روی دکمه تایید روی ثبت فرم کلیک شده و حالا باید به بک بگم اینم اطلاعات درخواستی
            // و بعدش باید یه لودر نشون بدم که داره ارسال میشه با توست
            toast.info("در حال ارسال فرم...");
            console.log(formData);
            let fieldData = formData.filter(v => v.fieldData)[0];
            fieldData = fieldData.fieldData
            let entityData = formData.filter(v => v.entityData)[0];
            entityData = entityData.entityData;
            debugger;
            _axios.post(`${localStorage.getItem("apiUrl2")}x/dm/`, {fieldData, entityData}).then((res) => {

                setNeedToReloadSidebar(fieldData)
                toast.success("فرم ثبت شده");


            });
        }

    }, [formData])

    return (
        <div>
            <form className="formChanges">
                <div className="title-template">
                    <div className="line"></div>
                    <div className="lable-box-title-new">
                        <label className="headLabel">افزودن</label>
                    </div>
                </div>


                <div className="selectWidthComplete">
                    <label htmlFor="id2" className=" control-label form-label labelMargin">نوع ورود اطلاعات</label>
                    <select onChange={inputDataType} className="inputBox" defaultValue={"1"}>
                        <option value="1">فرم های ثابت</option>
                        <option value="2">فرم ساز</option>
                    </select>
                </div>

                {valueState === "1" && <StaticForm/>}
                {valueState === "2" && <FormBuilder onSubmit={onSubmitHandler} submitText={"ثبت فرم ساز"}/>}

            </form>
        </div>
    );

};

export default MainFormBuilder;